import { SwiperButton } from './ImageCounter.styles'
import { Swiper as SwiperClass } from 'swiper/types'
import React from 'react'

export const NavButton = React.forwardRef<
  HTMLDivElement,
  {
    role: 'next' | 'prev'
    swiperRef: SwiperClass | undefined
  }
>((props, ref) => {
  const { role, swiperRef } = props
  const handleClick = () => {
    switch (role) {
      case 'next':
        swiperRef?.slideNext()
        break
      case 'prev':
        swiperRef?.slidePrev()
        break
    }
  }
  return <SwiperButton ref={ref} onClick={handleClick} theme={{ role: role }} />
})
